import React from 'react'
import { View, Text, Icon } from '../primitives'

const Container = View.extend.attrs({
	mt: 1,
	color: "secondaryTextColor",
})`
  overflow: hidden;
	& svg {
		margin-top: -3px;
	}
`

const Ellipsis = View.extend`
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export default ({ type, children }) => (
	<Container>
		<Ellipsis>
			{children && children.length > 0 && (
				<Icon icon={type || "education"} mr={2} size={20} />
			)}
			{children}
		</Ellipsis>
	</Container>
)